import i18next from 'i18next';

i18next.addResources('es', 'SelectOptions', {
  selectAll: 'Seleccionar todos',
  unselectAll: 'Ninguno'
});
